import React from "react";
import mainStyle from "../../dashboard.module.scss";
import { useTheme } from "@mui/material/styles";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import icn_grid_chart from "assets/images/icons/icn_grid_chart.svg";
import { mockLogs } from "../../const";

const SystemLog = ({ sortable, logs = mockLogs }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      className={`main-card-content ${mainStyle["dndObj_card"]} ${
        sortable === true ? mainStyle["dndObj_edit"] : ""
      }`}
    >
      <Box className={mainStyle["dndObj_title"]} sx={{ display: "flex", alignItems: "center" }}>
        <img src={icn_grid_chart} alt="system_log_icon" />
        <Typography component="span" sx={{ marginLeft: "10px" }}>System Log</Typography>
      </Box>

      <Box sx={{ flexGrow: 1, overflow: "hidden", px: 0, pb: 0, mt: 1.5 }}>
        <TableContainer
          sx={{
            maxHeight: "100%",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0, 0, 0, 0.35)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary", pl: 2 }}>Time</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary" }}>Operator</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary" }}>Category</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary" }}>Alert Type</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary", pr: 2 }}>Result</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((row, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell sx={{ fontSize: "13px", color: "text.secondary", whiteSpace: "nowrap", pl: 2 }}>
                      {row.time}
                    </TableCell>
                    <TableCell sx={{ fontSize: "13px", maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {row.operator}
                    </TableCell>
                    <TableCell sx={{ fontSize: "13px" }}>{row.category}</TableCell>
                    <TableCell sx={{ fontSize: "13px" }}>{row.alertType}</TableCell>
                    <TableCell
                      sx={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        pr: 2,
                        color:
                          row.result === "Success"
                            ? theme.palette.primary.greenPrimary
                            : theme.palette.primary.redPrimary,
                      }}
                    >
                      {row.result}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default SystemLog;
